// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mod-demo-ueditor {\n  position: relative;\n  z-index: 510;\n}\n.mod-demo-ueditor > .el-alert {\n    margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
